import React, { useEffect, useState } from 'react';
import { Editor, EditorState } from 'draft-js';
import { 
  Grid, 
  IconButton, 
  Tooltip, 
  Paper,
  Box,
  Typography,
  Fade
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@mui/icons-material/Close';
import TranslateIcon from '@mui/icons-material/Translate';
import { FaBookOpen } from "react-icons/fa";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { openLowerModalAndCloseLeftNavbar } from '../../../redux/handleSideNavBarAndModel/handleStatus.action';
import { checkAIRequestLimit } from '../../aiRequestLimit';
import CoAuther_TranslatorPage from './CoAuther_Translator/CoAuther_TranslatorPage';
import CoAuther_ParaphraserPage from './CoAuther_Paraphraser/CoAuther_ParaphraserPage';
import CoAuther_SummariserPage from './CoAuther_Summariser/CoAuther_SummariserPage';
import paraphrase_logo from "../../../static/Paraphrase 1.png";
import paraphrase_logo1 from "../../../static/Paraphraser_White.png";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: 'fixed',
    right: 0,
    top: '80px',
     width: '440px',
    // height: 'calc(97vh - 80px)',
    // height: "620px",
    height: 'calc(100vh - 110px)',  
    zIndex: 1000,
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '-8px 0 40px rgba(0, 0, 0, 0.15)',
   overflow: 'scroll',             
    display: 'flex',
    flexDirection: 'column',
  },
  mobileContainer: {
    position: 'fixed',
    top: '135px',
    right: '5px',
    width: '90%',
    height: 'calc(100vh - 145px)',
    zIndex: 1000,
    boxShadow: '0 12px 48px rgba(0, 0, 0, 0.18)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderBottom: '1px solid',
    flexShrink: 0,
  },
  tabsContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  tabButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    border: '2px solid',
    outline: 'none',
  },
  activeTabButton: {
    border: 'none',
  },
  contentArea: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      margin: '8px 0',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'linear-gradient(180deg, rgba(61, 131, 250, 0.3), rgba(142, 84, 233, 0.3))',
      borderRadius: '10px',
      border: '2px solid transparent',
      backgroundClip: 'padding-box',
      '&:hover': {
        background: 'linear-gradient(180deg, rgba(61, 131, 250, 0.5), rgba(142, 84, 233, 0.5))',
        backgroundClip: 'padding-box',
      },
    },
  },
  closeButton: {
    padding: '8px',
    borderRadius: '8px',
  },
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'blue',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const CoAuthorLowerModel = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { lowerModelOpen } = useSelector(state => state.handleModelAndSideBavBar);
  const userDetails = useSelector((user) => user);
  const userID = userDetails.user.currentUser._id;
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem('ThemeSwitch');
      setIsDarkMode(theme === 'true');
    };
    updateTheme();
    window.addEventListener('storage', updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === 'ThemeSwitch') {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener('storage', updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const deleteEditorFroSummarizer = (value) => {
    if (value === true) {
      props.handleDeleteinSummarizer(true);
    }
  };

  async function handleParaphrase() {
    // const checkailimit = await checkAIRequestLimit(userID);
    // if (checkailimit === false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    props.setTrackIsModalOpen(true);
    props.setTranslator(false);
    props.setSummariser(false);
    props.setParaphraser(true);
    dispatch(openLowerModalAndCloseLeftNavbar());
  }

  async function handleSummarise() {
    // const checkailimit = await checkAIRequestLimit(userID);
    // if (checkailimit === false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    props.setTrackIsModalOpen(true);
    dispatch(openLowerModalAndCloseLeftNavbar());
    props.setTranslator(false);
    props.setSummariser(true);
    props.setParaphraser(false);
  }

  async function handleTranslate() {
    // const checkailimit = await checkAIRequestLimit(userID);
    // if (checkailimit === false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    props.setTrackIsModalOpen(true);
    dispatch(openLowerModalAndCloseLeftNavbar());
    props.setTranslator(true);
    props.setSummariser(false);
    props.setParaphraser(false);
  }

  const TabButton = ({ active, onClick, icon, label, color, tooltip }) => {
    const buttonContent = (
      <div
        className={`${classes.tabButton} ${active ? classes.activeTabButton : ''}`}
        onClick={onClick}
        onMouseDown={(e) => e.preventDefault()} // Prevent default mousedown behavior
        style={{
          backgroundColor: active ? color : 'transparent',
          color: active ? '#fff' : (isDarkMode ? '#9ca3af' : color),
          borderColor: active ? 'transparent' : (isDarkMode ? '#374151' : '#e5e7eb'),
          pointerEvents: 'auto',
        }}
        onMouseEnter={(e) => {
          if (!active) {
            e.currentTarget.style.backgroundColor = isDarkMode ? '#374151' : '#f3f4f6';
          }
        }}
        onMouseLeave={(e) => {
          if (!active) {
            e.currentTarget.style.backgroundColor = 'transparent';
          }
        }}
      >
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          width: '20px',
          height: '20px'
        }}>
          {icon}
        </div>
        {active && !props.mobileView && (
          <span style={{ 
            fontSize: '13px', 
            fontWeight: 600,
            whiteSpace: 'nowrap'
          }}>
            {label}
          </span>
        )}
      </div>
    );

    return active ? buttonContent : (
      <CustomTooltip title={tooltip} arrow placement="bottom">
        <div style={{ display: 'inline-block' }}>
          {buttonContent}
        </div>
      </CustomTooltip>
    );
  };

  const containerStyle = {
    backgroundColor: isDarkMode ? '#1a1a1a' : '#FFFFFF',
  };

  const headerStyle = {
    backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
    borderBottomColor: isDarkMode ? '#374151' : '#e5e7eb',
  };

  return (
    <>
      {lowerModelOpen && (
        <Paper
          className={props.mobileView ? classes.mobileContainer : classes.modalContainer}
          style={containerStyle}
          elevation={0}
        >
          {/* Modern Header with Icon Tabs */}
          <div className={classes.header} style={headerStyle}>
            {/* Tool Icons */}
            <div className={classes.tabsContainer}>
              {/* Paraphrase Button */}
              <TabButton
                active={props.paraphraser}
                onClick={handleParaphrase}
                icon={
                  <img 
                    src={props.paraphraser ? paraphrase_logo1 : paraphrase_logo} 
                    alt="Paraphrase" 
                    style={{ 
                      width: '20px',
                      height: '20px',
                      transition: 'all 0.3s ease',
                    }} 
                  />
                }
                label="Paraphrase"
                color="#7C3AED"
                tooltip="Paraphrase"
              />
              
              {/* Summarize Button */}
              <TabButton
                active={props.summariser}
                onClick={handleSummarise}
                icon={
                  <FaBookOpen 
                    style={{ 
                      width: '18px', 
                      height: '18px',
                      transition: 'all 0.3s ease',
                    }} 
                  />
                }
                label="Summarize"
                color="#EF4444"
                tooltip="Summarize"
              />
              
              {/* Translator Button */}
              <TabButton
                active={props.translator}
                onClick={handleTranslate}
                icon={
                  <TranslateIcon 
                    style={{ 
                      width: '20px',
                      height: '20px',
                      transition: 'all 0.3s ease',
                    }} 
                  />
                }
                label="Translator"
                color="#F59E0B"
                tooltip="Translator"
              />
            </div>
            
            {/* Close Button */}
            <IconButton
              className={classes.closeButton}
              onClick={props.handleCloseTranslate}
              size="small"
              style={{ 
                 backgroundColor: isDarkMode ? '#3b1f1f' : '#fee2e2',
                 color: '#dc2626',
                 transition: 'all 0.3s ease'
              }}
            >
              <CloseIcon style={{ fontSize: '20px' }} />
            </IconButton>
          </div>

          {/* Scrollable Content Area */}
          <Box className={classes.contentArea}>
            <Fade in={true} timeout={500}>
              <div>
                {props.translator && (
                  <CoAuther_TranslatorPage
                    isDarkMode={isDarkMode}
                    mobileView={props.mobileView}
                    editorState={props.editorState}
                    setEditorState={props.setEditorState}
                    onGrandchildStateChange={props.onChildStateChange}
                    editorRef={props.editorRef}
                    editorValue={props.editorValue}
                  />
                )}
                {props.summariser && (
                  <CoAuther_SummariserPage
                    isDarkMode={isDarkMode}
                    mobileView={props.mobileView}
                    righteditorContent={props.righteditorContent}
                    handleDeleteinSummarizer={deleteEditorFroSummarizer}
                    CallSummarise={props.callSummarise}
                    editorState={props.editorState}
                    setEditorState={props.setEditorState}
                    editorValue={props.editorValue}
                  />
                )}
                {props.paraphraser && (
                  <CoAuther_ParaphraserPage
                    isDarkMode={isDarkMode}
                    mobileView={props.mobileView}
                    editorState={props.editorState}
                    setEditorState={props.setEditorState}
                    callGrammerCheck={props.callGrammerCheck}
                    firstTime={props.firstTime}
                    setFirstTime={props.setFirstTime}
                    sharedState={props.sharedState}
                    editorValue={props.editorValue}
                  />
                )}
              </div>
            </Fade>
          </Box>
        </Paper>
      )}
    </>
  );
};

export default CoAuthorLowerModel;